import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../components/nav/Footer.js';
import '../styles/contact-pages.css';
import content from '../assets/content.json';

export default function ContactPageInfo() {
  const navigate = useNavigate();

  useEffect(() => {
    const FORM_TARGET = "#hubspot-form-wrapper";

    const loadForm = () => {
      const wrapper = document.querySelector(FORM_TARGET);
      if (wrapper) wrapper.innerHTML = "";

      let attempts = 0;
      const maxAttempts = 20;

      const interval = setInterval(() => {
        if (window.hbspt?.forms) {
          window.hbspt.forms.create({
            region: "na1",
            portalId: "50260926",
            formId: "1584bfc3-192b-481f-8c23-06e07c078f1c",
            target: FORM_TARGET,
          });
          clearInterval(interval);
        } else if (attempts > maxAttempts) {
          clearInterval(interval);
          console.error("HubSpot script did not initialize in time");
        }
        attempts++;
      }, 300);
    };

    loadForm();

    const onPageShow = (event) => {
      if (event.persisted) {
        loadForm();
      }
    };

    window.addEventListener("pageshow", onPageShow);

    return () => {
      window.removeEventListener("pageshow", onPageShow);
    };
  }, []);

  const infoContent = content.contactPageInfo;

  const referencesSection = infoContent.listSections?.find(
    (s) => s.sectionTitle?.includes("check our references")
  );

  const otherListSections = infoContent.listSections?.filter(
    (s) => !s.sectionTitle?.includes("check our references")
  );

  return (
    <HelmetProvider>
      <Helmet>
        <title>{content.metadata.contactPageInfoMetadata.title}</title>
        <meta name="description" content={content.metadata.contactPageInfoMetadata.description} />
      </Helmet>
      <div>
        <div className="claims-form-wrapper">
          <div className="claims-form-splash">
            <div className="logo-wrapper">
              <Link to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logos/logo-top.png`}
                  alt="TrustPro Logo"
                />
              </Link>
            </div>
            <div className="claims-splash-text">
              {infoContent.headerOne && (
                <p className="claims-header-one">{infoContent.headerOne}</p>
              )}
              {infoContent.subHead && (
                <p className="claims-subhead">{infoContent.subHead}</p>
              )}
            </div>
          </div>
          <div className="claims-content-background">
            <div className="claims-content">
              <div className="text-column">
                {infoContent.introSections?.map((section, i) => (
                  <div key={`intro-${i}`} className="intro-section">
                    {section.sectionTitle && <h2>{section.sectionTitle}</h2>}
                    {section.paragraphs?.map((p, idx) => (
                      <p key={idx}>{p}</p>
                    ))}
                  </div>
                ))}
                {otherListSections?.map((section, sectionIndex) => (
                  <div
                    key={`list-${sectionIndex}`}
                    className="list-section list-section-contact"
                  >
                    {section.sectionTitle && <h3>{section.sectionTitle}</h3>}
                    {section.sectionIntro && <p>{section.sectionIntro}</p>}
                    {section.listType === "number" ? (
                      <ol>
                        {section.sectionItems?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ol>
                    ) : (
                      <ul>
                        {section.sectionItems?.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}
                    {section.sectionTitle?.includes("TrustPro™ Difference") && (
                      <div className="mobile-only">
                        {referencesSection && (
                          <div className="list-section list-section-contact" style={{ marginTop: "40px" }}>
                            {referencesSection.sectionTitle && (
                              <h3>{referencesSection.sectionTitle}</h3>
                            )}
                            <ul>
                              {referencesSection.sectionItems?.map((item, i) => (
                                <li key={i}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ))}
                {infoContent.subHeadTwo && (
                  <h2 className="claims-subhead-two">{infoContent.subHeadTwo}</h2>
                )}
              </div>
              <div className="form-column">
                <div className="claims-form">
                  <div id="hubspot-form-wrapper"></div>
                </div>
                {referencesSection && (
                  <div className="list-section list-section-contact under-form" style={{ marginTop: "40px" }}>
                    {referencesSection.sectionTitle && (
                      <h3>{referencesSection.sectionTitle}</h3>
                    )}
                    <ul>
                      {referencesSection.sectionItems?.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}
